/* eslint-disable jsx-a11y/heading-has-content, react/no-array-index-key */
/* eslint-disable no-shadow */
import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Section, ReactAux } from '@jkhy/vsg-design-system';

import { Base, BaseType as BaseType_ } from '../common/base-component';
import { AppState as AppState_ } from '../../redux/app-state';
import { healthCheck, HealthCheckModel as HealthCheckModel_ } from '../../redux/actions/health-check-actions';
import { getLoanApplicationsHistory } from '../../redux/actions/loan-application-actions';
import { GET_LOAN_APPLICATION_HISTORY_FAIL, GET_LOAN_APPLICATION_HISTORY_SUCCESS } from '../../redux/actions/actionTypes/loan-applications';
import LoanApplicationHistoryModel_ from '../../data/models/LoanApplicationHistory';
import Grid, { Column as Column_ } from '../common/grid/grid';
import { formatDate, isNullOrWhiteSpace } from '../../utils/helper';
import PublicContent from '../../data/models/PublicContent';
import { AppDispatch } from '../../data/models/AppDispatch';
import '../../../css/default.css';

export const PageDataUI = 'LoanApplicationHistory';

type LoanApplicationHistoryProps = {
  healthCheck: HealthCheckModel_,
  loanApplicationHistory: LoanApplicationHistoryModel_[],
  getLoanApplicationsHistory: () => Promise<typeof GET_LOAN_APPLICATION_HISTORY_SUCCESS | typeof GET_LOAN_APPLICATION_HISTORY_FAIL>
  healthCheckAction: () => Promise<{ payload: HealthCheckModel_ }>
} & BaseType_

export class LoanApplicationHistory extends Base<LoanApplicationHistoryProps, {}> {
  async componentDidMount() {
    const { getLoanApplicationsHistory, healthCheckAction, } = this.props;

    const { payload: { isChecked, status, }, } = await healthCheckAction();

    if (isChecked && status === 200) {
      await getLoanApplicationsHistory();
    }
  }

  getApplicationURL = (value: string): string => {
    const { loanApplicationHistory, } = this.props;
    const app = loanApplicationHistory.find(x => x.appNumber === value);
    const qdModelTypeStr = (app.qdModelTypeStr || '').toLowerCase();
    const onlineAppUrl = isNullOrWhiteSpace(window.onlineApplicationURL) ? window.quickDecisionV2URL : window.onlineApplicationURL;

    if (qdModelTypeStr === 'external') return `${onlineAppUrl}/resume/${app.applicationCode}/${app.uid}/`;

    return '';
  };

  mapStatus = (status: string) => {
    switch (status) {
      case 'OnHold':
      case 'HoldRemoved': return 'In Review';
      case 'WaitingOnCoApplicant': return 'Waiting On Co-Applicant';
      case 'ClosedExpired': return 'Closed-Expired';
      case 'ApprovedExpired': return 'Approved-Expired';
      case 'ClosedAnnul': return 'Closed Annul';
      case 'ApprovedWithdrawn': return 'Approved Withdrawn';

      default:
        return status;
    }
  };

  content = () => {
    const { loanApplicationHistory: applicationsHistory, healthCheck, } = this.props;

    const columns: Array<Column_> = [{
      title: 'Application #:',
      field: 'appNumber',
      cell: (cellValue) => {
        const url = this.getApplicationURL(cellValue);
        const result = url ? (
          <a
            className="text-primary"
            href={url}
            data-ui={`application-link-app-number-${cellValue}`}
          >
            {cellValue}
          </a>
        )
          : cellValue;
        return result;
      },
    },
    {
      title: 'Created:',
      field: 'createDate',
      cell: (cellValue) => {
        return formatDate(cellValue);
      },
    },
    {
      title: 'Submitted:',
      field: 'dateSubmitted',
      cell: (cellValue) => {
        return formatDate(cellValue);
      },
    },
    {
      title: 'Status:',
      field: 'applicationStatusStr',
      cell: (cellValue) => {
        return this.mapStatus(cellValue);
      },
    },
    {
      title: 'Borrower:',
      field: 'customerPortalDisplayName',
      cell: (cellValue) => {
        const parser = new DOMParser();
        const decodedCellValue = parser.parseFromString(cellValue, 'text/html').body.textContent;
        return decodedCellValue;
      },
    }];

    if (healthCheck?.isChecked && healthCheck?.status !== 200) {
      return (
        <Section
          title="Loan Application History"
          dataUI={PageDataUI}
        >
          <p className="mb-3">{healthCheck.status}</p>
        </Section>
      );
    }

    const { loanApplicationHistoryPageTitle, loanApplicationHistoryPageDescription, } = window?.PublicContent ?? new PublicContent();

    return (
      <ReactAux>
        <Section dataUI={PageDataUI}>
          <h1 data-ui={`${PageDataUI}-page-title`} className="mb-2 text-preline break-word">{loanApplicationHistoryPageTitle}</h1>
          <p data-ui={`${PageDataUI}-page-description`} className="mb-3 text-preline break-word">{loanApplicationHistoryPageDescription}</p>

          <Grid
            data={applicationsHistory}
            columns={columns}
            className="history-table-wrapper"
            dataUI="ApplicationHistoryWrapper"
          />
        </Section>
      </ReactAux>
    );
  }
}

export default withRouter(connect(
  (state: AppState_) => ({
    healthCheck: state.healthCheck,
    loanApplicationHistory: state.loanApplicationHistory,
  }),
  (dispatch: AppDispatch) => {
    return {
      getLoanApplicationsHistory: () => dispatch(getLoanApplicationsHistory()),
      healthCheckAction: () => dispatch(healthCheck()),
    };
  }
)(LoanApplicationHistory));
